import { Preferences } from '@capacitor/preferences';

import { state } from '@helpers/user-data-stencil-store';
export class UserDataController { 

    // --------user_name--------
    setUserName = async (value) => {
        console.log("setUserName", value);
        await Preferences.set({key: 'user_name', value: value});
    };

    getUserName = async () => {
        const { value } = await Preferences.get({key: 'user_name'});
        console.log("getUserName", value);
        return value;
    };

    // ---------user_surname--------
    setUserSurname = async (value) => {
        console.log("setUserSurname", value);
        await Preferences.set({key: 'user_surname', value: value});
    };

    getUserSurname = async () => {
        const { value } = await Preferences.get({key: 'user_surname'});
        return value;
    };

     // -----------------user_api_key-----------------
    setUserApiKey = async (value) => {
        await Preferences.set({key: 'user_api_key', value: value});
    };

    getUserApiKey = async () => {
        const { value } = await Preferences.get({key: 'user_api_key'});
        return value;
    };

    // -----------------user_email-----------------
    setUserEmail = async (value) => {
        await Preferences.set({key: 'user_email', value: value});
    };

    getUserEmail = async () => {
        const { value } = await Preferences.get({key: 'user_email'});
        return value;
    };

    // -----------------user_walletaddress-----------------
    setUserWalletAddress = async (value) => {
        await Preferences.set({key: 'user_walletaddress', value: value});
    };

    getUserWalletAddress = async () => {
        const { value } = await Preferences.get({key: 'user_walletaddress'});
        console.log("3333 getUserWalletAddress", value);
        return value;
    };

    clearUserWalletAddress = async () => { 
    await Preferences.remove({key: 'user_walletaddress'});
     };

    // -------user_id--------
    setUserId = async (value) => {
        console.log("setUserId", value);
        await Preferences.set({
            key: 'user_id',
            value: JSON.stringify(value),
        });
    };

    getUserId = async () => {
        const { value } = await Preferences.get({
            key: 'user_id'
        });
        return value;
    };


    //-------Logout-------
        doLogout = async () => {
            console.log('state', state);
        await Preferences.clear();
    };
}

export const UserData = new UserDataController();